// import node module libraries
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Tab, Card, Nav, Breadcrumb } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// import sub custom components
import SystemLogsTable from './SystemLogsTable';

const AllSystemLogs = ({ activeKey }) => { // activeKey als Prop erhalten
  const { t } = useTranslation(); // useTranslation-Hook

  return (
    <Fragment>
      <Row>
        <Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
          <Tab.Container defaultActiveKey="all">
            <Card>
              <Card.Header className="border-bottom-0 p-0 bg-white">
                <Nav className="nav-lb-tab">
                  <Nav.Item>
                    <Nav.Link eventKey="all" className="mb-sm-3 mb-md-0">
                      {t('All Logs')}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="error" className="mb-sm-3 mb-md-0">
                      {t('Error')}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="warning" className="mb-sm-3 mb-md-0">
                      {t('Warning')}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="info" className="mb-sm-3 mb-md-0">
                      {t('Info')}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="heartbeat" className="mb-sm-3 mb-md-0">
                      {t('Heartbeat')}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Card.Header>
              <Card.Body className="p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="all" className="pb-4">
                    <SystemLogsTable filterBy="" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="error" className="pb-4">
                    <SystemLogsTable filterBy="error" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="warning" className="pb-4">
                    <SystemLogsTable filterBy="warning" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="info" className="pb-4">
                    <SystemLogsTable filterBy="info" />
                  </Tab.Pane>
                  <Tab.Pane eventKey="heartbeat" className="pb-4">
                    <SystemLogsTable filterBy="heartbeat" />
                  </Tab.Pane>
                </Tab.Content>
              </Card.Body>
            </Card>
          </Tab.Container>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AllSystemLogs;
